import React from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';

/**
 * Light-gray directional connector between workflow nodes. Renders
 * horizontally by default, or as a vertical chevron when `vertical`.
 */
export default function WorkflowConnector({ vertical }) {
  if (vertical) {
    return (
      <div className="wf-arrow down" aria-hidden="true">
        <ChevronDown />
      </div>
    );
  }
  return (
    <div className="wf-arrow" aria-hidden="true">
      <ArrowRight />
    </div>
  );
}
